import 'react-calendar/dist/Calendar.css';
import './App.scss';
import 'react-json-pretty/themes/monikai.css';
import React from 'react';
import { Login } from './components/content-panes/login/login';
import { alert } from 'react-bootstrap-confirmation';
import SearchResults from './components/homepage/searchresults/searchresults';
import Demoform from './components/homepage/demoform/demoform';
import Pricingprelogin from './components/homepage/pricingprelogin/pricingprelogin';
import ContactSales from './components/homepage/contact-sales/contact-sales';
import Navbarfaq from './components/homepage/resources-FAQ/faq';
import Resourcesblog from './components/homepage/resources-blog/blog';
import Policy from './components/homepage/resources-policy/policy';
import ContactUs from './components/homepage/resources-contact-us/contact-us';
import AboutUs from './components/homepage/resources-about-us/about-us';
import BlogDetails from './components/homepage/resources-blogdetails/blogdetails';
import { decodeJWT } from './services/candidateService';
import { AdminContainer } from './landing-pages/adminContainer';
import { HomePage } from './components/homepage/homePage';
import { ClientContainer } from './landing-pages/clientContainer';
import useCurrentPath from './utils/useCurrentPath';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { current } from '@reduxjs/toolkit';
import Navbarsection from './components/homepage/navbarsection/navbarsection';
import Footersection from './components/homepage/footersection/footersection';
import { CandidateHomePage } from './components/candidates/candidateHomepage/candidateHomepage';
import CandidateRegister from './components/candidates/candidateHomepage/candidateRegistration/candidateRegistration';
import CandidateRegistration from './components/candidates/candidateHomepage/candidateRegister/candidateRegister';
import { CandidateContainer } from './landing-pages/candidateContainer';
import { DataEntryTeamLeadContainer } from './landing-pages/dataEntryTeamLeadContainer';
import { DataEntryExecutiveContainer } from './landing-pages/dataEntryExecutiveContainer';
import CareerGuidanceHomepage from './components/homepage/careerguidance/careerGuidanceHomepage';
window.alert = alert;

const AppContainer = () => {
  const location = useLocation();
  const excludedPaths = ['/demoform', '/contact-sales', '/registration', '/candidate/dashboard', '/candidate/registration', '/candidate/details', '/candidate/value-add', '/candidate/password-reset'];
  const headerExcludedPaths = ['/registration', '/candidate/dashboard', '/candidate/registration', '/candidate/details', '/candidate/value-add', '/candidate/password-reset']

  return (
    <>
      {!headerExcludedPaths.includes(location.pathname) && <Navbarsection />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path='/candidate-homepage' element={<CandidateHomePage />} />
           <Route
          path="/career-guidance"
          element={<CareerGuidanceHomepage />}
        />
        <Route path='/registration' element={<CandidateRegister />} />
        <Route path='/candidate/registration' element={<CandidateRegistration />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/demoform" element={<Demoform />} />
        <Route path="/contact-sales" element={<ContactSales />} />
        <Route path="/pricing-prelogin" element={<Pricingprelogin />} />
        <Route path="/navbar-faq" element={<Navbarfaq />} />
        <Route path="/resources-blog" element={<Resourcesblog />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/blogdetails" element={<BlogDetails />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      {!excludedPaths.includes(location.pathname) && <Footersection />}
    </>
  );
};

const App = () => {
  const loginToken = window.localStorage.getItem('authToken');
  const currentPath = useCurrentPath();

  if (!loginToken) {
    if (currentPath === '/login') {
      return <Login />;
    }

    if (
      currentPath.startsWith('/candidate') &&
      currentPath !== '/candidate-homepage' &&
      currentPath !== '/candidate/registration'
    ) {
      window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
      return null;
    }
  }

  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  if (decoded) {
    const tokenExpiry = new Date(decoded.exp * 1000);
    console.log('Token Expiry:', tokenExpiry);
    if (tokenExpiry < new Date()) {
      window.localStorage.removeItem('authToken');
      window.location.reload();
    }
  }

  const role = decoded.roles;
  let container = null;
  switch (role) {
    case 'CLIENT_PRIMARY':
    case 'CLIENT_USER':
      container = <ClientContainer />;
      break;
    case 'CANDIDATE':
      container = <CandidateContainer />;
      break;
    case 'ADMIN':
      container = <AdminContainer />;
      break;
    case 'DATA_ENTRY_TL':
      container = <DataEntryTeamLeadContainer />;
      break;
    case 'DATA_ENTRY_EXE':
      container = <DataEntryExecutiveContainer />;
      break;
    default:
      container = (
        <BrowserRouter>
          <AppContainer />
        </BrowserRouter>
      );
  }
  return container;
};

export default App;